import MapPin, { MapIconType } from '../pin/MapPin';

function someIcon(iconType: MapIconType, workerId?: number, hideNumber?: boolean) {
  return (
    <MapPin
      iconType={iconType}
      {...(workerId !== undefined && { workerId })}
      {...(hideNumber !== undefined && { hideNumber })}
    />
  );
}

export default someIcon;
